// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"9743bc3f","113":"8638e954","168":"1cbe5943","246":"fc8b63f9","318":"340b80c5","488":"4ee5d76a","854":"048ea64d","950":"f9915655"}[chunkId] + ".chunk.js";
};